import type { ReactNode } from 'react';
import { Dialog, Button } from './ui';
import type { ButtonVariant } from './ui';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** 確認ボタンの見た目（破壊的操作は 'danger'） */
  variant?: ButtonVariant;
  /** 確認ボタンを処理中表示にする */
  loading?: boolean;
  /** 確認ボタンだけを無効化する（loading と違い、閉じる操作は妨げない）。
   *  提示すべき情報が揃うまで確認させたくない場合に使う。 */
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * 汎用の確認ダイアログ。破壊的・課金など「すんなり通したくない」操作の前に挟む。
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = '確認',
  cancelLabel = 'キャンセル',
  variant = 'primary',
  loading = false,
  confirmDisabled = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={() => { if (!loading) onClose(); }}
      title={title}
      size="sm"
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            variant={variant}
            onClick={onConfirm}
            loading={loading}
            disabled={loading || confirmDisabled}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      {message && <div className="text-sm text-gray-700 leading-relaxed">{message}</div>}
    </Dialog>
  );
}
